

document.addEventListener("scroll", () => {
  if (!document.querySelector(".cta-video__video")) return;
  const { top } = document.querySelector(".cta-video").getBoundingClientRect();
  document.querySelector(
    ".cta-video__video"
  ).style.transform = `translateY(${-1 * top}px)`;
});

document.addEventListener("click", ({ target }) => {
  if (!target.matches(".sticky-banner__close")) return;
  target.closest('.sticky-banner').classList.add('sticky-banner--hidden');
  createCookie('hide_sticky_banner', true, 7);
});

function createCookie(name, value, days) {
  let expires;
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}
